<script>
import {tableRelevant} from "@/pages/projectImpl/js/utils";

export default {
  name: "importResource",
  props: {
    visible: Boolean,
    seriesInfo: Object
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  data() {
    return {
      searchForm: {
        name: undefined,
      },
      columns: [
        {title: '资源包名称', scopedSlots: {customRender: 'name'}},
        {title: '资源个数', scopedSlots: {customRender: 'count'}},
        {title: '文件大小', scopedSlots: {customRender: 'size'}},
        {title: '更新时间', dataIndex: 'updateTime'},
        {title: '状态', scopedSlots: {customRender: 'enabled'}},
        {title: '操作', scopedSlots: {customRender: 'action'}},
      ],
      table: tableRelevant.call(this),
      confirmLoading: false,
    };
  },
  computed: {
    rowSelection() {
      return {
        /*getCheckboxProps: record => ({
          props: {
            disabled: !record.enabled
          },
        }),*/
        onChange: (selectedRowKeys, selectedRows) => {
          this.table.selectedRowKeys = selectedRowKeys;
          const addList = [];
          this.table.selectedRows = selectedRows.concat(this.table.selectedRows).reduce((p, c) => {
            if (this.table.selectedRowKeys.includes(c.id) && !addList.includes(c.id)) {
              p.push(c);
              addList.push(c.id);
            }
            return p;
          }, []);
        },
      };
    },
  },
  watch: {
    visible(bool) {
      bool && this.getPageList(1);
    },
  },
  mounted() {
    this.getPageList(1);
  },
  methods: {
    getPageList(pageIndex) {
      const Params = {
        pageIndex: pageIndex || this.table.tablePagination.current,
        pageSize: this.table.tablePagination.pageSize,
        ...this.searchForm,
      };
      this.table.tableLoading = true;
      this.$http.CourseResource.ResourcePackagePagelist(Params).then(({data}) => {
        this.table.tableDataSource = data.items;
        this.table.tablePagination.current = data.pageIndex;
        this.table.tablePagination.total = data.totalCount;
      }).finally(() => {
        this.table.tableLoading = false;
      });
    },
    searchReset() {
      this.searchForm = {
        name: undefined,
      };
      this.getPageList(1);
    },
    toDetail(record) {
      this.onCancel();
      this.$router.push({
        path: '/course/resources/detail',
        query: {
          id: record.id,
          params: JSON.stringify(record),
        },
      });
    },
    onOk() {
      this.confirmLoading = true;
      const Params = {
        "seriesId": this.seriesInfo.id,
        "resourcePackageIds": this.table.selectedRowKeys
      }
      this.$http.CourseResource.ImportPackage(Params).then(res => {
        this.$message.success(res.message);
        this.$emit("ok", 1);
        this.onCancel();
      }).finally(() => {
        this.confirmLoading = false;
      });
    },
    onCancel() {
      this.$emit("change", false);
      this.table.selectedRowKeys = [];
      this.table.selectedRows = [];
      this.searchForm.name = undefined;
    },
  },
};
</script>

<template>
  <a-modal title="导入资源包" :visible="visible" width="70%"
           :centered="true"
           :destroyOnClose="true"
           :confirm-loading="confirmLoading"
           @ok="onOk"
           @cancel="onCancel">
    <a-form-model layout="inline" class="search-form" :model="searchForm">
      <a-form-model-item label="资源包名称">
        <a-input :maxLength="30" allowClear v-model="searchForm.name" placeholder="请输入资源包名称"/>
      </a-form-model-item>
      <a-form-model-item>
        <a-button @click="getPageList(1)" type="primary" html-type="button">
          查询
        </a-button>
        <a-button @click="searchReset" style="margin-left: 10px;">
          重置
        </a-button>
      </a-form-model-item>
    </a-form-model>
    <a-table :columns="columns" :data-source="table.tableDataSource" :loading="table.tableLoading"
             :scroll="{y: 400}" row-key="id"
             :row-selection="rowSelection" :pagination="table.tablePagination">
      <div slot="name" slot-scope="text">
        <img :src="text.icon | filterUrl" alt="" style="width: 24px; height: 24px;object-fit: cover;">
        {{text.name}}
      </div>
      <a-switch slot="enabled" slot-scope="text" :checked="text.enabled"
                @click="changeStatus(text)"
                v-auth="`enabled-resource`"
                checked-children="启用"
                un-checked-children="禁用"/>
      <div slot="enabled" slot-scope="text">
        {{text.enabled ? "启用" : "禁用"}}
      </div>
      <div slot="count" slot-scope="text">
        <span>{{ text.count || 0 }}</span>
      </div>
      <div slot="size" slot-scope="text">
        <span>{{ text.size || '--' }}</span>
      </div>
      <div slot="action" slot-scope="text">
        <a style="margin-right: 10px" href="javaScript:;" @click="toDetail(text)"> 查看</a>
      </div>
    </a-table>
    <div style="float: left;margin-top: -42px;">已选择资源包 <span
      style="color:#f00;">{{ table.selectedRowKeys.length }}</span> 个
    </div>
  </a-modal>
</template>

<style scoped lang="less">
</style>
